import React, { useId } from 'react';
import { cn } from '../../utils/cn';

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  label: string;
  description?: React.ReactNode;
  disabled?: boolean;
  id?: string;
  className?: string;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onCheckedChange, label, description, disabled, id, className }) => {
  const generatedId = useId();
  const switchId = id ?? generatedId;
  return (
    <div className={cn('flex items-start justify-between gap-3', className)}>
      <span className="flex flex-col">
        <label htmlFor={switchId} className={cn('text-sm font-medium text-ink', !disabled && 'cursor-pointer')}>
          {label}
        </label>
        {description && <span className="text-sm text-muted">{description}</span>}
      </span>
      <button
        type="button"
        id={switchId}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        className={cn(
          'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-page',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          checked ? 'bg-brand' : 'bg-line-strong'
        )}
      >
        <span
          className={cn(
            'inline-block h-5 w-5 rounded-full bg-card transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0.5'
          )}
        />
      </button>
    </div>
  );
};
